/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_ActiveInputs */

const vi_product_active = /** @type {(inputs: Product_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang hoạt động`)
};

/**

* @param {Product_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_active = /** @type {((inputs?: Product_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_active(inputs)
});